var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "link-info-short-component",
      attrs: { href: _vm._f("validateURL")(_vm.link.url) }
    },
    [
      _vm.imgURL ? _c("CoverImg", { attrs: { src: _vm.imgURL } }) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "textContent", class: { notitle: !_vm.link.title } },
        [
          _c("div", [_vm._v(_vm._s(_vm.source))]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.link.title))])
        ]
      ),
      _vm._v(" "),
      _vm.with_delete
        ? _c(
            "button",
            {
              staticClass: "btn__reset",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.$emit("delete")
                }
              }
            },
            [_c("i", { staticClass: "icon-close_bold color__secondary_60" })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }